<template>
  <div class="fe-upload" style="height: 32px !important;line-height: 32px; display: flex; align-items: center;">
    <el-button v-if="downloadUrl" class="btn-font" @click.native.stop.prevent="dialogVisible = true" size="small" type="primary">
      <i class="iconfont icon-yunduanshangchuan"></i><label>{{buttonName}}</label>
    </el-button>
    <div v-if="downloadUrl">
      <el-dialog
        :visible.sync="dialogVisible"
        :title="title"
        v-if="downloadUrl"
        class="upload-dialog"
        width="30%" style="height: auto;min-height: 100px">
        <div style="min-height: 77px">
          <div class="download-excel" v-if="downloadUrl">
            <span class="link-type"  style="text-underline: #00a0e9 !important;" :href="downloadUrl" :download="downloadName" @click.stop="getDownload">{{downLoadTitle}}</span>
          </div>
          <el-upload
            :action=" BASE_API + path"
            :before-remove="beforeRemove"
            :file-list="fileList"
            :headers="{enctype:'multipart/form-data'}"
            :limit="limit"
            :accept="fileType"
            :multiple="multiple"
            :on-error="uploadError"
            :on-exceed="handleExceed"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :on-success="uploadSuccess"
            :show-file-list="showFileList"
            :with-credentials="withCredentials"
            class="upload-demo"
            :name="fileName">
            <el-button class="btn-font" size="small" type="primary">
              <label>上传</label>
            </el-button>
            <div class="el-upload__tip" slot="tip">{{tip}}</div>
          </el-upload>
        </div>
        <span class="dialog-footer" style="min-height: 40px"  slot="footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
        </span>
      </el-dialog>
    </div>

    <el-upload
      v-else
      :action=" BASE_API + path"
      :before-remove="beforeRemove"
      :file-list="fileList"
      :headers="{enctype:'multipart/form-data'}"
      :limit="limit"
      :multiple="multiple"
      :accept="fileType"
      :on-error="uploadError"
      :on-exceed="handleExceed"
      :on-preview="handlePreview"
      :on-remove="handleRemove"
      :on-success="uploadSuccess"
      :show-file-list="showFileList"
      :with-credentials="withCredentials"
      class="upload-demo"
      :name="fileName">
      <el-button class="btn-font" size="small" type="primary"><i class="iconfont icon-yunduanshangchuan"></i><label>{{buttonName}}</label>
      </el-button>
    </el-upload>
  </div>
</template>
<script>
  import { exportSend } from '@/api/report.js'
  const callback = {
    refresh: true,
    showMessage: true,
    autoClose: true
  }
  export default {
    name: 'fe-upload',
    props: {
      event: {
        type: Object,
        default() {
          return {
            path: '',
            callback
          }
        }
      },
      title: {
        type: String,
        default: '上传文件'
      },
      fileName: {
        type: String,
        default: 'inputfile'
      },
      fileType: {
        type: String,
        default: '.xlsx'
      },
      downLoadTitle: {
        type: String,
        default: '请下载模板'
      },
      code: {
        type: String,
        default: ''
      },
      buttonName: {
        type: String,
        default: '上传'
      },
      downloadUrl: { // 下载模板的路径
        type: String,
        default: ''
      },
      downloadName: {
        type: String,
        default: '模板Excel'
      },
      multiple: {
        type: Boolean,
        default: false
      },
      showFileList: {
        type: Boolean,
        default: false
      },
      limit: {
        type: Number
      },
      path: {
        type: String,
        required: true
      },
      ajaxType: {
        type: String,
        default: 'get'
      },
      tip: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        dialogVisible: false,
        fileList: [],
        BASE_API: process.env.BASE_API,
        withCredentials: true
      };
    },
    methods: {
      isIE() {
        if (!!window.ActiveXObject || "ActiveXObject" in window) {
          return true;
        } else {
          return false;
        }
      },
      getDownload() {
        exportSend(this.downloadUrl, this.ajaxType, { noLoading: true }).then(res => {
          console.error(res)
          const blob = res.data
          const fileName = this.downloadName + this.fileType
          if (this.isIE()) {
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            var a = document.createElement('a')
            var url = window.URL.createObjectURL(blob)
            a.href = url
            a.download = fileName
            document.body.appendChild(a)
            a.click()
            setTimeout(() => {
              window.URL.revokeObjectURL(url)
              document.body.removeChild(a)
            }, 200)
          }
        })
      },
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePreview(file) {
        console.log(file);
      },
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择  ${this.limit} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${file.name}？`);
      },
      // 上传成功
      uploadSuccess(res) {
        debugger
        const event = this.event
        if (res.code === 0) {
          if (event && !event.callback) {
            event['callback'] = callback
          }
          if (event && event.callback.showMessage) {
            this.$message.success(res.message || '上传成功')
          }
          if (event && event.callback.refresh) {
            this.$nextTick(() => {
              this.$bus.$emit('refresh-grid', null, this.code)
            })
          }
          if (event && event.callback.autoClose) {
            this.dialogVisible = false
          }
        } else {
          this.uploadError(res)
        }
      },
      // 上传文件失败
      uploadError(err) {
        console.error('上传失败', err)
        const msg = err && err.message
        this.$message.error(msg)
      }
    }
  }
</script>
<style rel="stylesheet/scss" lang="scss">
  .fe-upload{
    .upload-dialog{
      .el-dialog__title{
        color: #000;
      }
      .el-dialog{
        height: auto;
      }
      .el-dialog__body{
        min-height: 77px;
      }
    }
    .download{
      position: relative;
      a{
        line-height: 30px;
        position: absolute;
        text-align: center;
        top: 0px;
        left: 0;
        bottom: 0;
        right: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/FromBase/upload/index.vue